import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarDispatchRecordsQueryAtom = createQueryAtomFactory(
  'calendar.dispatchRecords',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => ({
    complianceDispatchRecords: {
      __args: {
        filter: {
          fromSubmittedAt: `${params.fromDate}T00:00:00Z`,
          toSubmittedAt: `${params.toDate}T23:59:59Z`,
          ...(params.facilityId ? { facilityId: params.facilityId } : {}),
        },
        pagination: {
          limit: 500,
          offset: 0,
        },
      },
      entries: {
        id: true,
        facilityId: true,
        dispatchType: true,
        status: true,
        submittedAt: true,
        externalReferenceId: true,
        errorType: true,
        batchId: true,
        facility: {
          id: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
);
